import CompanyOwners from './CompanyOwners'

export default CompanyOwners
